import * as React from 'react';
import PropTypes from 'prop-types';

import { Modal } from 'react-bootstrap';

export default class RevertImportModal extends React.Component {
  static propTypes = {
    revertingImport: PropTypes.object,
    onCancelRevert: PropTypes.func.isRequired,
    onRevert: PropTypes.func.isRequired,
  };

  render() {
    const {
      revertingImport,
      onRevert,
      onCancelRevert,
    } = this.props;

    return (
      <Modal
        className="revert-imports-modal"
        show={revertingImport != null}
        onHide={onCancelRevert}
      >
        <Modal.Header closeButton>
          <Modal.Title>Revert Import</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="bottom-buffer-sm">You are about to delete the following Import:</div>
          <div><strong>{revertingImport.name}</strong></div>
          <div className="top-buffer-sm">
            This action is permanent.
            You will lose all data that was added to Buildout from this import.
            Are you sure you want to delete?
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="pull-right">
            <button className='btn btn-sm btn-cancel' onClick={onCancelRevert}>
              Cancel
            </button>
            <button className='btn btn-sm btn-danger ml-2' onClick={onRevert}>
              Revert Import
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    );
  }
}